import * as React from 'react';
import { useEffect } from 'react';
import { JourneyNavigationHandler, Routes } from '../../../routes';
import { useOrgStore } from '../../../hooks/useOrgStore';
import { observer } from 'mobx-react';
import { CreateAppPage } from './CreateAppPage';

export const SmartCreateAppPage: React.FC<{ handler: JourneyNavigationHandler<Routes.CREATE_APP> }> = observer(
  (props) => {
    const orgStore = useOrgStore();
    const { params } = props.handler;
    const org = orgStore.org(params.org_id);

    useEffect(() => {
      (async () => {
        const org = await orgStore.resolve(params.org_id);
        await org.loadApps();
      })();
    }, []);

    if (!org) {
      return null;
    }

    return <CreateAppPage {...props} org={org} />;
  }
);
